export default __webpack_public_path__ + "static/media/coinGeckoLogoWhite.e64f3733.png";